import BillingHTTP from 'utils/billing-http';

class CurrentStudentService {
  signIn(params) {
    return BillingHTTP.postContent('/dashboard-api/v2/sessions/sign-in', params);
  }

  facebookSignIn(accessToken) {
    return BillingHTTP.postContent('/dashboard-api/v2/sessions/facebook/sign-in', { access_token: accessToken });
  }

  googleSignIn(accessToken) {
    return BillingHTTP.postContent('/dashboard-api/v2/sessions/google/sign-in', { access_token: accessToken });
  }

  impersonationToken() {
    return BillingHTTP.getContent('/dashboard-api/v2/sessions/token');
  }

  validateCPF(cpf) {
    return BillingHTTP.getContent('/dashboard-api/v2/students/validate-cpf', { cpf });
  }

  loadStudent() {
    return BillingHTTP.getContent('/dashboard-api/v2/current-student');
  }

  update(studentDataUpdated) {
    return BillingHTTP.putContent('/dashboard-api/v2/current-student', { student: studentDataUpdated });
  }

  loadAddress(cep) {
    return BillingHTTP.getContent(`/zip-codes/search?zip_code=${cep}`);
  }

  loadRecoverPasswordChannels(cpfHash) {
    return BillingHTTP.getContent('/dashboard-api/v2/forgot-password/channels', { cpf_hash: cpfHash });
  }

  generateConfirmationToken(params) {
    return BillingHTTP.postContent('/dashboard-api/v2/esqueci-minha-senha', params);
  }

  validateConfirmationToken(params) {
    return BillingHTTP.getContent('/dashboard-api/v2/esqueci-minha-senha', params);
  }

  resetPassword(params) {
    return BillingHTTP.postContent('/dashboard-api/v2/resetar-minha-senha', params);
  }

  confirmStudentEmail(emailId) {
    return BillingHTTP.postContent(`/dashboard-api/v2/emails/${emailId}/confirm`);
  }
}

export default new CurrentStudentService();
